import React, {useState, useEffect, useContext} from 'react';
import {useParams} from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import Container from "@material-ui/core/Container";
import Card from "@material-ui/core/Card";

import {
  API_DOMAIN_URL_RESELLER, API_SECTION_RESELLER_LISTINGS, API_SECTION_REMITT_1,
  API_SECTION_REMITT_2, API_SECTION_REMITT_TRAVELERS
} from '../../Constants';
import {RemittanceContext, devConsolelog, getApi, AppContext} from '../../Utility';
import RemitDetailsForm from './detailForm';
import TravelerCard from './travelerCard';

const PAN_FRONT_KEY = 'pancard_front';
const PASSPORT_BACK_KEY = 'passport_back';
const PASSPORT_FRONT_KEY = 'passport_front';
let updateInitialState = {}
updateInitialState[PAN_FRONT_KEY] = false;
updateInitialState[PASSPORT_BACK_KEY] = false;
updateInitialState[PASSPORT_FRONT_KEY] = false;
const formDataInitialState = {
  name: '',
  passport_issuedToPersonName: '',
  passport_number: '',
  pancard_number: '',
  passport_front: null,
  passport_front_id: null,
  passport_back_id: null,
  pancard_front_id: null,
  passport_back: null,
  pancard_front: null,
  passport_issue_date: '',
  passport_expiry_date: '',
  passport_issue_place: '',
  docsUpdated: updateInitialState
}

const useStyles = makeStyles(theme => ({
  // root: {
  //   padding: theme.spacing(0),
  //   cursor: 'pointer',
  //   '&:hover': {
  //     boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
  //     // transform: 'scale(1.03)'
  //   }
  // },
  mainContainer: {
    // display: 'flex',
    // alignItems: 'center',
    // '&> div': {
    //   margin: 'auto'
    // }
    margin: '30px auto'
  },
  progress: {
    height: 20
  },
  cardsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    '&>div': {
      width: 250,
      margin: '20px 0px',
      height: 160,
      [theme.breakpoints.down('sm')]: {
        maxWidth: '80%'
      }
    }
  },
  paperContent: {
    width: '100%',
    height: 'calc(100% - 20px)',
    // textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    '&> div': {
      margin: 'auto'
    }
  },
  card: {
    borderRadius: 15
  },
  bookingTitle: {
    margin: theme.spacing(1)
  }
}));

export default () => {
  const classes = useStyles();
  const [selectedTraveler, setSelectedTraveler] = useState(null);
  const [formData, setFormData] = useState([]);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [bookingTitle, setBookingTitle] = useState(''); //TRKLS | Australia | 5 pax | 23rd Dec | 4 Nights
  const [mainTravellerDone, setMainTravellerDone] = useState(false);
  const {remit_id = null} = useParams();

  const {setViewSnackbar} = useContext(AppContext);

  // const remit_id = "tjyhb"

  useEffect(() => {
    devConsolelog('remit details effecr');
    let newFormData = []
    let getBookingData = async () => {
      let {data = null,err = null} = await getApi(`${API_DOMAIN_URL_RESELLER}${API_SECTION_RESELLER_LISTINGS}${API_SECTION_REMITT_1}${remit_id}${API_SECTION_REMITT_2}`)
      if(err) // TODO: handle error
      if(!data) return;
      if(Array.isArray(data)) data = data[0];
      let {booking= {}} = data;
      let {adults_count = 0, children_count = 0, code = remit_id, nights_count = '', destination = {}, departure_at = ''} = booking;
      let totalPassengers = adults_count + children_count;
      for(let i=0; i<totalPassengers; i++) newFormData.push({...formDataInitialState});
      devConsolelog('remit travellers data booking ', newFormData);
      setFormData(newFormData)
      setBookingTitle(`${code.toUpperCase()} | ${destination.name || ''} | ${Number(adults_count) + Number(children_count)} pax | ${departure_at} | ${nights_count} nights`)
      getTravellersData();
    }

    let getTravellersData = async () => {
      let {data: travelers = null, status, err = null} = await getApi(`${API_DOMAIN_URL_RESELLER}${API_SECTION_RESELLER_LISTINGS}${API_SECTION_REMITT_1}${remit_id}${API_SECTION_REMITT_TRAVELERS}`)
      if(err) {} // TODO: handle error
      if(travelers && travelers.length > 0) {
        devConsolelog('data OK ', travelers, travelers.length > 0)
        setMainTravellerDone(true);
      }
      else if(!travelers || status == 404) return;
      let apiFormData = [...newFormData];
      devConsolelog('remit travellers travelers ', travelers, newFormData, apiFormData);
      travelers.forEach((item, index) => {
        if(index < newFormData.length) {
          let newData = apiFormData[index];
          if(item.name) newData['name'] = item.name;
          if(item.id) newData['travellerId'] = item.id;
          let data = item.document;
          devConsolelog('remit travellers data each ', index, apiFormData[index]);

          if(!data || data.length < 0) return;
          data.forEach((doc, docIndex) => {
            if(doc.type == "pan") {
              if(doc.id_number) newData['pancard_number'] = doc.id_number;
              if(doc.page_type === "front" && doc.file) newData['pancard_front'] = {name: doc.file};
              if(doc.id) newData['pancard_front_id'] = doc.id;
            }
            else if(doc.type == "passport") {
              if(doc.id_number) newData['passport_number'] = doc.id_number;
              if(doc.expiry_date) newData['passport_expiry_date'] = doc.expiry_date;
              if(doc.issue_date) newData['passport_issue_date'] = doc.issue_date;
              if(doc.issued_to_person_name) newData['passport_issuedToPersonName'] = doc.issued_to_person_name;
              if(doc.issue_place) newData['passport_issue_place'] = doc.issue_place;

              if(doc.page_type === "front" && doc.file) {
                newData['passport_front'] = {name: doc.file};
                if(doc.id) newData['passport_front_id'] = doc.id;
              }
              else if(doc.page_type === "back" && doc.file) {
                newData['passport_back'] = {name: doc.file};
                if(doc.id) newData['passport_back_id'] = doc.id;
              }
            }
          })
          devConsolelog('remit travellers data each final newData ', newData)
          apiFormData[index] = newData;
        } else setViewSnackbar({message: "Something went wrong!", type: "error"})
      })
      setDetailsLoading(false);
      devConsolelog('remit travellers data final newFormData ', apiFormData)
      setFormData(apiFormData)
    }

    getBookingData();
  }, [])

  console.log('remit travellers data render ', formData, mainTravellerDone);
  const contextValue = {
    selectedTraveler,
    setSelectedTraveler,
    formData,
    setFormData,
    remit_id,
    mainTravellerDone,
    setMainTravellerDone
  }
  return (<Container className={classes.mainContainer}>
    <RemittanceContext.Provider value={contextValue}>
      <Card raised className={classes.card}>
        <Typography align="center" variant="h5" color="secondary" className={classes.bookingTitle}>Booking Id: {bookingTitle}</Typography>
        {
          selectedTraveler
          ? (<RemitDetailsForm />)
          : (<>
            <Typography align="center" variant="h5" color="textSecondary">REMITTANCE DOCUMENTS UPLOAD</Typography>
            <div className={classes.cardsContainer}>
              {
                formData.map((item, index) => (<TravelerCard data={item} index={index} detailsLoading={detailsLoading} disable={index>0 && !mainTravellerDone} key={index} />))
              }
            </div>
          </>)
        }
      </Card>
    </RemittanceContext.Provider>
  </Container>);
}
